'use strict';

import {DataStructure} from '~/shared/src/utilities/dataStructure';

/**
 * Builds a fake DataStructure for query string based queries.
 *
 * @return {DataStructure}
 */
export const getDataStructureForSqlQuery = () : DataStructure => {
    return {
        id    : '0',
        origId: 0,

        item: {
            id  : 0,
            key : 'queriesDataObject',
            name: 'dataObject for queries'
        }
    }
};
